/**
 * Delivery settings API client (BFF: `/api/v1/store/settings/delivery`).
 *
 * Covers the delivery settings document plus provider CRUD and provider
 * connection testing. Secrets are write-only on upsert and never returned.
 */
import { apiClient } from '@/shared/api';
import type {
  DeliverySettings,
  ProviderSummary,
  ProviderUpsertRequest,
  TestConnectionResult,
  UpdateDeliverySettingsRequest,
} from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/delivery';

export const getDeliverySettings = async (): Promise<DeliverySettings> =>
  (await apiClient.get<DeliverySettings>(BASE)).data;

export const updateDeliverySettings = async (
  body: UpdateDeliverySettingsRequest,
): Promise<DeliverySettings> => (await apiClient.put<DeliverySettings>(BASE, body)).data;

export const listDeliveryProviders = async (): Promise<ProviderSummary[]> =>
  (await apiClient.get<ProviderSummary[]>(`${BASE}/providers`)).data;

export const createDeliveryProvider = async (
  body: ProviderUpsertRequest,
): Promise<ProviderSummary> =>
  (await apiClient.post<ProviderSummary>(`${BASE}/providers`, body)).data;

export const updateDeliveryProvider = async (
  providerId: string,
  body: ProviderUpsertRequest,
): Promise<ProviderSummary> =>
  (await apiClient.put<ProviderSummary>(`${BASE}/providers/${providerId}`, body)).data;

export const deleteDeliveryProvider = async (providerId: string): Promise<void> => {
  await apiClient.delete(`${BASE}/providers/${providerId}`);
};

export const testDeliveryProviderConnection = async (
  providerId: string,
): Promise<TestConnectionResult> =>
  (await apiClient.post<TestConnectionResult>(`${BASE}/providers/${providerId}/test-connection`))
    .data;
